<template>
  <div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('realmonitor.tab1')" name="first"></el-tab-pane>
        <el-tab-pane
          :label="$t('realmonitor.tab2')"
          name="second"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <el-row :gutter="15">
        <el-col :span="5">
          <div
            style="border: 1px solid #c5d0e2; border-radius: 4px; padding: 20px"
          >
            <span class="page_sub_title">{{
              $t("realmonitor.page_title")
            }}</span>
            <el-divider></el-divider>
            <el-form :model="form" :size="size">
              <el-form-item :label="$t('vehicle.carNo')">
                <el-select
                  style="width: 100%"
                  filterable
                  v-model="form.VID"
                  :placeholder="$t('public.select')"
                >
                  <el-option
                    v-for="item in vehicles.data"
                    v-if="item.treeLevel == 5"
                    :key="item.nodeValue"
                    :label="item.name"
                    :value="item.nodeValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="车型：">
                                <el-input v-model="form.vehiclemodel" disabled></el-input>
                            </el-form-item> -->
              <el-form-item :label="$t('realmonitor.upTime')">
                <el-input :value="vehicleInfo.updatetime" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('realmonitor.monitorStatus')">
                <el-input
                  :value="
                    monitorStatus
                      ? $t('realmonitor.moniting')
                      : $t('realmonitor.unmonitor')
                  "
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label-width="0" style="margin-top: 8px">
                <el-button
                  style="width: 100%"
                  v-if="monitorStatus"
                  type="primary"
                  @click="onStopMonitorClick"
                  block
                  >{{ $t("realmonitor.stopMonitor") }}</el-button
                >
                <el-button
                  style="width: 100%"
                  v-else
                  type="primary"
                  @click="onStartMonitorClick"
                  block
                  >{{ $t("realmonitor.startMonitor") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="19">
          <div
            v-show="activeName == 'first'"
            style="
              border: 1px solid #c5d0e2;
              border-radius: 4px;
              padding: 20px;
              height: calc(100vh - 275px);
              overflow: hidden;
            "
          >
            <el-row :gutter="15">
              <el-col :span="14">
                <div>
                  <span class="page_sub_title">{{
                    $t("realmonitor.runChart")
                  }}</span>
                  <el-row style="margin-top: 15px; margin-bottom: 30px">
                    <el-col :span="6">
                      <div>
                        <KLGauge
                          type="motor_speed"
                          :value="
                            vehicleInfo.motorSpeed
                              ? parseFloat(vehicleInfo.motorSpeed)
                              : 0
                          "
                          :title="$t('realmonitor.motorSpeed')"
                          unit="rpm"
                        />
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div>
                        <KLGauge
                          type="speed"
                          :value="
                            vehicleInfo.speed
                              ? parseFloat(vehicleInfo.speed)
                              : 0
                          "
                          :title="$t('realmonitor.speed')"
                          color="#FF106E"
                          unit="km/h"
                        />
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div>
                        <KLGauge
                          type="motor_temperature"
                          :value="
                            vehicleInfo.motorControllerTemperature
                              ? parseInt(vehicleInfo.motorControllerTemperature)
                              : 0
                          "
                          :title="$t('realmonitor.motorControllerTemperature')"
                          unit="℃"
                        />
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div>
                        <KLGauge
                          type="battery_temperature"
                          :value="
                            vehicleInfo.maxTemperature
                              ? convertTemp(vehicleInfo.maxTemperature)
                              : 0
                          "
                          :title="$t('realmonitor.batteryTemperature')"
                          unit="℃"
                        />
                      </div>
                    </el-col>
                  </el-row>
                  <!--滚动-->
                  <div style="height: calc(100vh - 485px); overflow: auto">
                    <span
                      class="page_sub_title"
                      style="display: inline-block"
                      >{{ $t("realmonitor.wholeInfo") }}</span
                    >
                    <el-row style="margin: 0" :gutter="10">
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showGear(vehicleInfo.gear)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("gear.title")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showChargingState(vehicleInfo.chargingState)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("recharge.chargingState")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showTotalVoltage(vehicleInfo.totalVoltage)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("vehicle.totalVoltage")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showTotalCurrent(vehicleInfo.totalCurrent)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("vehicle.totalCurrent")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showSOC(vehicleInfo.soc)
                          }}</span>
                          <span class="page_sub_title">SOC</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showMotorControllerTemperature(
                              vehicleInfo.motorControllerTemperature
                            )
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.motorControllerTemperature")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showMotorVoltage(vehicleInfo.motorVoltage)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.motorVoltage")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showMotorCurrent(vehicleInfo.motorCurrent)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.motorCurrent")
                          }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <span
                      class="page_sub_title"
                      style="margin-top: 30px; display: inline-block"
                      >{{ $t("realmonitor.extremeValueInformation") }}</span
                    >
                    <el-row style="margin: 0; margin-bottom: 30px;overflow: auto" :gutter="10">
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showVoltageSingle(vehicleInfo.maxVoltageSingle)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.maxVoltageSingle")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showVoltageSingle(vehicleInfo.minVoltageSingle)
                          }}</span>
                          <span class="page_sub_title"
                            >{{ $t("realmonitor.minVoltageSingle") }}
                          </span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showVoltageBatteryNo(
                              vehicleInfo.minVoltageBatteryNo
                            )
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.minVoltageBatteryNo")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showVoltageBatteryNo(
                              vehicleInfo.minVoltageSingleBatteryNo
                            )
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.minVoltageSingleBatteryNo")
                          }}</span>
                        </div>
                      </el-col>

                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showMaxTemperature(vehicleInfo.maxTemperature)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.maxTemperature")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showMaxTemperature(vehicleInfo.minTemperature)
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.minTemperature")
                          }}</span>
                        </div>
                      </el-col>
                      <el-col :span="6" style="margin-top: 20px">
                        <div class="monitor_item">
                          <span class="page_title">{{
                            showBatteryInsulationResistance(
                              vehicleInfo.batteryInsulationResistance
                            )
                          }}</span>
                          <span class="page_sub_title">{{
                            $t("realmonitor.batteryInsulationResistance")
                          }}</span>
                        </div>
                      </el-col>
                    </el-row>
                    <span
                      v-if="false"
                      class="page_sub_title"
                      style="margin-top: 30px; display: inline-block"
                      >能耗信息</span
                    >
                    <el-form
                      v-if="false"
                      :inline="true"
                      :size="size"
                      style="margin-top: 15px; margin-bottom: 15px"
                    >
                      <el-form-item label="查询时间:">
                        <el-date-picker
                          v-model="form2.date"
                          style="width: 140px"
                          type="date"
                          placeholder="选择日期"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label-width="0">
                        <el-time-select
                          v-model="form2.btime"
                          style="width: 120px"
                          :picker-options="{
                            start: '08:30',
                            step: '00:15',
                            end: '18:30',
                          }"
                          placeholder="选择时间"
                        >
                        </el-time-select
                        ><span style="font-size: 12px">至</span
                        ><el-time-select
                          style="width: 120px"
                          v-model="form2.etime"
                          :picker-options="{
                            start: '08:30',
                            step: '00:15',
                            end: '18:30',
                          }"
                          placeholder="选择时间"
                        >
                        </el-time-select>
                      </el-form-item>

                      <el-form-item>
                        <el-button type="primary" plain>查询</el-button>
                      </el-form-item>
                    </el-form>
                    <div v-if="false">
                      <span class="page_sub_title" style="display: inline-block"
                        >基本信息</span
                      >
                      <div
                        style="
                          padding: 15px;
                          border: 1px solid #c5d0e2;
                          margin-top: 15px;
                          border-radius: 4px;
                          margin-bottom: 30px;
                        "
                      >
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">{{ vehicleInfo.gear }}</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">
                              {{ vehicleInfo.chargingState }}
                            </div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              {{ $t("recharge.chargingState") }}
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">
                              {{ vehicleInfo.totalVoltage }}
                            </div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              总电压
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">
                              {{ vehicleInfo.totalCurrent }}
                            </div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              总电流
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                            "
                          >
                            <div class="page_title">{{ vehicleInfo.soc }}</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              SOC
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="page_sub_title" style="display: inline-block"
                        >电耗信息</span
                      >
                      <div
                        style="
                          padding: 15px;
                          border: 1px solid #c5d0e2;
                          margin-top: 15px;
                          border-radius: 4px;
                          margin-bottom: 30px;
                        "
                      >
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">前进挡</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">前进挡</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">前进挡</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                              border-right: 1px solid #a2b1cb;
                            "
                          >
                            <div class="page_title">前进挡</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                        <div style="display: inline-block; width: 20%">
                          <div
                            style="
                              display: inline-block;
                              width: 100%;
                              text-align: center;
                            "
                          >
                            <div class="page_title">前进挡</div>
                            <div
                              class="page_sub_title"
                              style="opacity: 0.5; margin-top: 8px"
                            >
                              档位
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div
                  style="
                    height: calc(100vh - 275px);
                    overflow-y: auto;
                    overflow-x: hidden;
                    width: 100%;
                  "
                >
                  <span class="page_sub_title">{{
                    $t("realmonitor.totalVoltageStateDiagram")
                  }}</span>
                  <div
                    id="chart_voltage"
                    style="width: 100%; height: 250px"
                  ></div>
                  <span class="page_sub_title">{{
                    $t("realmonitor.totalCurrentStateDiagram")
                  }}</span>
                  <div
                    id="chart_current"
                    style="width: 100%; height: 250px"
                  ></div>
                  <span class="page_sub_title">{{
                    $t("realmonitor.satellitePositioningInformation")
                  }}</span>
                  <KingLongMap
                    mapId="klmap_real"
                    ref="map"
                    style="margin-top: 15px; width: 100%; height: 250px"
                  />
                  <div style="height: 50px;margin-top: 20px;"></div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div
            v-show="activeName == 'second'"
            style="
              border: 1px solid #c5d0e2;
              border-radius: 4px;
              padding: 20px;
              height: calc(100vh - 255px);
              overflow: auto;
            "
          >
            <baseinfo :vid="vid" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import KLGauge from "@/components/KLGauge";
import KingLongMap from "@/components/KingLongMap";
import { mapState } from "vuex";
// import * as echarts from "echarts";
import settings from "@/settings";
import baseinfo from "./vehiclebaseinfo";
export default {
    name:"realmonitor",
  components: {
    KLGauge,
    KingLongMap,
    baseinfo,
  },
   
  data() {
    return {
      vid: 0,
      monitorStatus: false, //监控状态
      updateTime: "",
      activeName: "first",
      value: 30,
      form: {
        VID: "",
      },
      marker: undefined,
      vehicleInfo: {},
      form2: {
        date: new Date(),
        btime: "",
        etime: "",
      },
      chart_voltage: undefined,
      chart_current: undefined,
      xData: [],
      voltageData: [],
      currentData: [],
    };
  },
  methods: {
    showBatteryInsulationResistance(val) {
      if (!val) return "--";
      return val + " KΩ";
      // val = parseInt(val, 10);
      // if ((val & 0xffffff) !== 0) {
      //     val = val & 0xffff;
      //     if (val >= 0 && val <= 5000)
      //         return val + ' KΩ';
      // }
      return "--";
    },
    showMaxTemperature(val) {
      if (!val) return "--";

      return this.convertTemp(val) + " ℃";
    },
    convertTemp(val) {
      return parseFloat(val);

      // val = parseInt(val, 10);
      // val = (val * 0.1 - 40).toFixed(1);
      // if (val >= -20 && val <= 50)
      //     return val;
      // return 0;
    },
    showVoltageBatteryNo(val) {
      if (!val) return "--";
      return val;
    },
    showVoltageSingle(val) {
      if (!val) return "--";
      return val + " V";
      // val = parseInt(val, 10);
      // val = (val * 0.001).toFixed(4);
      // if (val >= 0 && val <= 5)
      //     return val + ' V';

      // return "--";
    },
    showMotorCurrent(val) {
      if (!val) return "--";
      return val + " A";
      // val = parseInt(val);
      // if (val >= -500 && val <= 500)
      //     return val + ' A';
      // return "--";
    },
    showMotorVoltage(val) {
      if (!val) return "--";
      return val + " V";
      // val = parseInt(val);
      // if (val >= 0 && val <= 720)
      //     return val + ' V';
      // return "--";
    },
    showSOC(val) {
      if (!val) return "--";
      val = parseInt(val);
      return val + " %";
    },
    showMotorControllerTemperature(val) {
      if (!val) return "--";
      return val + " ℃";
      // val = parseInt(val);
      // if (val >= -40 && val <= 100) {
      //     return val + ' ℃';
      // }
      // return "--";
    },
    showTotalCurrent(val) {
      if (!val) return "--";
      return val + " A";
      // val = parseInt(val, 10);
      // if (val == 65535) return val;
      // if (val <= 5000) {
      //     val = val * 10 - 500;
      // }
      // else {
      //     val = val * 0.1 - 1000;
      // }

      // if ((val & 0x8000) == 32768) {
      //     val = val - 65536;
      // }
      // return val.toFixed(2);
    },
    showTotalVoltage(val) {
      if (!val) return "--";
      return val + " V";
      // val = parseInt(val, 10);
      // return (val * 0.1).toFixed(2) + " V";
    },

    showChargingState(val) {
      //充放电状态
      if (!val) return "--";
      val = parseInt(val);
      switch (val) {
        case 0:
          return this.$t("recharge.uncharged");
        case 1:
          return this.$t("recharge.charging");
        // case 2: return "充电满";
        // case 3: return "充电故障";
      }

      return "--";
    },
    showGear(val) {
      if (!val) return "--";
      //挡位标准
      val = parseInt(val); 
      switch (val) {
        case 0:
          return this.$t("gear.neutral");
        case 1:
          return this.$t("gear.forward");
        case 2:
          return this.$t("gear.backOff");
        case 3:
          return this.$t("gear.stopIt");
      }
      return "--";
    },
    onStopMonitorClick() {
      this.monitorStatus = false;
      this.vid = 0;
    },
    onStartMonitorClick() {
      //请选择监控车辆
      if (!this.form.VID) {
        this.$message.warning(this.$t("realmonitor.pleaseMonitorVehicle"));
        return;
      }
      // this.form.VID = 106312
      this.vid = parseInt(this.form.VID);
      // this.vid = 100844
      this.monitorStatus = true;

      if (this.monitorStatus && this.vid) {
        this.getRealTimeData(1);
      }
    },
    handleClick() {},
    updateChart() {
      if (this.chart_voltage)
        this.chart_voltage.setOption({
          xAxis: [
            {
              data: this.xData,
            },
          ],
          series: [
            {
              data: this.voltageData,
            },
          ],
        });

      if (this.chart_current)
        this.chart_current.setOption({
          xAxis: [
            {
              data: this.xData,
            },
          ],
          series: [
            {
              data: this.currentData,
            },
          ],
        });
    },
    initChart() {
      if (!this.chart_voltage)
        this.chart_voltage = echarts.init(
          document.getElementById("chart_voltage")
        );
      if (!this.chart_current)
        this.chart_current = echarts.init(
          document.getElementById("chart_current")
        );
      var option = {
        grid: {
          top: 40,
          bottom: 40,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            color: "rgba(15,26,58,0.5)",
            fontSize: 12,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "rgba(15,26,58,0.5)",
            fontSize: 12,
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#2A7AFF",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(42,122,255,0.00)", // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: "rgba(42,122,255,0.30)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
          },
        ],
      };

      this.chart_voltage.setOption(option);
      this.chart_current.setOption(option);
    },
    updateGpsInfo() {
      console.log(this.vehicleInfo);
      if (this.$refs.map) {
        // console.log('updateGpsInfo')
        if (this.vehicleInfo) {
          this.$refs.map.removeMarkerById("v_" + this.vehicleInfo.VehicleID);
        }
        this.$refs.map.addMarker(
          "v_" + this.vehicleInfo.VehicleID,
          "",
          this.vehicleInfo.lon,
          this.vehicleInfo.lat,
          "assets/svgs/icon_loc_online_0.svg"
        );

        this.$refs.map.setCenter(this.vehicleInfo.lon, this.vehicleInfo.lat);
      }
    },

    getRealTimeData(val) {
      //获取实时数据
      this.$api
        .realTimeVehicleInfo(this.form)
        .then((res) => {
          if (res && res.code == 200 && res.data) {
            if (!this.vehicleInfo) {
              //不存在
              this.vehicleInfo = res.data;
              this.vehicleInfo.VehicleID = this.form.VID;
              this.xData = [];
              this.voltageData = [];
              this.currentData = [];

              this.xData.push(this.vehicleInfo.updatetime.split(" ")[1]);
              this.voltageData.push(this.vehicleInfo.totalVoltage);
              this.currentData.push(this.vehicleInfo.totalCurrent);
              this.updateChart();
              this.updateGpsInfo();
            } else {
              if (
                this.vehicleInfo.updatetime != res.data.updatetime &&
                res.data.updatetime
              ) {
                this.vehicleInfo = res.data;
                if (val == 1) {
                  this.xData = [];
                  this.voltageData = [];
                  this.currentData = [];
                }
                this.xData.push(this.vehicleInfo.updatetime.split(" ")[1]);
                this.voltageData.push(this.vehicleInfo.totalVoltage);
                this.currentData.push(this.vehicleInfo.totalCurrent);
                this.updateChart();
                this.updateGpsInfo();
              }
            }
          }
        })
        .catch(() => {});
    },

    init() {
      this.$store.dispatch("app/closeSideBar");
      if (this.timer != null) clearInterval(this.timer);

      if (this.timer == null) {
        setInterval(() => {
          if (this.monitorStatus && this.vid) {
            this.getRealTimeData();
          }
        }, 15 * 1000);
      }

      this.$nextTick(() => {
        this.initChart();
      });
    },
  },
  watch: {
    "form.VID": {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.monitorStatus = false;
          this.vid = 0;
        }
      }, 
    },
    selectedVehicles: {
      handler: function (val, oldVal) {
       
        if (val && val.length > 0) {
          this.form.VID = val[0].nodeValue;
        }
      },
    },
  },
  destroyed() {
    if (this.timer != null) clearInterval(this.timer);

    this.$store.dispatch("app/openSideBar");
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.app.vehicles,
       selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
    size() {
      return this.$store.getters.size;
    },
  },


  mounted() {
     const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    //关闭左侧
    this.init();

    // console.log(this.vehicles)
    // setTimeout(() => {
    //     this.value = 120
    // }, 5000);
  },
};
</script>
<style scoped lang="scss">
.monitor_item {
  height: 76px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  border: 1px solid rgb(197, 208, 226);
  border-radius: 4px;
  text-align: center;

  span {
    display: block;
  }

  .page_sub_title {
    margin-top: 8px;
    opacity: 0.5;
    display: block;
    font-size: 10px !important;
  }
}

::-webkit-scrollbar-thumb {
  background: #2a7aff;
}
</style>
